import React from "react";

import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { HelpOutline } from "@material-ui/icons";

const useStyles = makeStyles(theme => ({
  tabSubTitle: {
    background: "#aaa",
    padding: 8,
    marginBottom: 16,
    textTransform: "capitalize"
  },
  tabItem: {
    padding: "4px 8px"
  },
  marginBottom: {
    marginBottom: theme.spacing(3)
  }
}));

export const WelcomeContent = () => {
  const classes = useStyles();

  return (
    <Grid container direction="column">
      <Grid item>
        <Typography>
          <strong>Welcome</strong>
        </Typography>
      </Grid>
      <Typography
        wrap="nowrap"
        className={clsx(classes.tabItem, classes.marginBottom)}
      >
        You may navigate to any section of the Chapter Financials Report by
        using the menu above, or simply click on the <code>Continue</code>{" "}
        button below to move into the next section.
      </Typography>
      <Grid item>
        <Typography>
          <strong>Saving work</strong>
        </Typography>
      </Grid>
      <Typography
        wrap="nowrap"
        className={clsx(classes.tabItem, classes.marginBottom)}
      >
        Everything you push <code>Submit</code>
        on a form your work is saved and can be revisited at a later date.
      </Typography>
      <Typography>
        <strong>Help</strong>
      </Typography>
      <Typography
        wrap="nowrap"
        className={clsx(classes.tabItem, classes.marginBottom)}
      >
        Click on the help icon
        <HelpOutline /> in each section for additional help.
      </Typography>
    </Grid>
  );
};

export default WelcomeContent;
